import createReactComponent from '../createReactComponent';
export default createReactComponent('components', 'IconComponents', [
  ['path', { d: 'M3 12l3 3l3 -3l-3 -3z', key: 'svg-0' }],
  ['path', { d: 'M15 12l3 3l3 -3l-3 -3z', key: 'svg-1' }],
  ['path', { d: 'M9 6l3 3l3 -3l-3 -3z', key: 'svg-2' }],
  ['path', { d: 'M9 18l3 3l3 -3l-3 -3z', key: 'svg-3' }],
]);
